export enum MKMetadataType {
    /**
     * Used for custom messages between the sender and the remote receiver, such as a Chromecast receiver app.
     */
    CAST = "CAST",

    /**
     * HLS #EXT-X-CUE-OUT, #EXT-X-CUE-OUT-CONT and #EXT-X-CUE-IN tags are surfaced with this type.
     */
    CUETAG = "CUETAG",

    /**
     * All custom, i.e. unknown/unsupported HLS tags are surfaced with this type.
     */
    CUSTOM = "CUSTOM",

    /**
     * HLS #EXT-X-DATERANGE tags are surfaced with this type.
     */
    DATERANGE = "DATERANGE",

    /**
     * EMSG data from MP4 container formats are surfaced with this type. See MetadataType.ID3 for the MPEG-2 TS equivalent.
     */
    EMSG = "EMGS",

    /**
     * DASH EventStream events (also known as MPD Events) are surfaced with this type.
     */
    EVENT_STREAM = "EVENT-STREAM",

    /**
     * ID3 tags from MPEG-2 Transport Stream container formats are surfaced with this type.
     */
    ID3 = "ID3",

    /**
     * HLS #EXT-X-SCTE35 tags are surfaced with this type.
     */
    SCTE = "SCTE"
}